import React from 'react';
import PropTypes from 'prop-types';

import { sentenceCase } from 'change-case';
import isCartPastLimit from '../../helpers/cart/isCartPastLimit';
import determineLimit from '../../helpers/cart/determineLimit';

import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import LoadingButton from '@mui/lab/LoadingButton';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

const DetailedCardContent = (props) => {
	const {
		confirmAddition,
		handleAddToCart,
		hasBeenAdded,
		quantity,
		setQuantity,
		selectedGiftCard,
		siteId,
		subtotal,
		userBalance
	} = props;

	const handleQuantitySelect = () => {
		const menuItems = [];
		const limit = determineLimit(subtotal, siteId, userBalance?.totalLeft);

		for (let index = 1; index <= limit; index++) {
			menuItems.push(
				<MenuItem key={index} value={index}>
					{index}
				</MenuItem>
			);
		}
		return menuItems;
	};

	const isDisabled =
		isCartPastLimit(subtotal, siteId, userBalance?.totalLeft) ||
		userBalance?.nextAvailablePurchaseDate;

	return (
		<Stack
			justifyContent='center'
			className='filter'
			sx={{
				flexDirection: { xs: 'column', sm: 'column', md: 'row', lg: 'row' },
				p: { xs: 0, sm: 0, md: 5 },
				mt: { xs: 11, sm: 13 },
				background: (theme) => theme.palette.common.white
			}}
		>
			<Box
				sx={{
					'& img': { width: '100%', objectFit: 'contain', height: { xs: '130px', sm: '180px' } }
				}}
			>
				<img
					src={selectedGiftCard?.image}
					alt={`$${selectedGiftCard.amount} ${selectedGiftCard.company} Gift Card`}
				/>
			</Box>
			<Box
				className='togglebg'
				sx={{ ml: { xs: 0, sm: 0, md: 10, lg: 20 }, p: { xs: 2, sm: 2, md: 0 } }}
			>
				<Stack spacing={2}>
					<Typography color='#757575' sx={{ fontSize: { xs: '0.8rem', sm: '0.8rem', md: '1rem' } }}>
						{`Home / ${sentenceCase(selectedGiftCard?.category)} / $${selectedGiftCard?.amount} ${
							selectedGiftCard?.company
						} Gift Card`}
					</Typography>
					<Typography
						variant='h1'
						sx={{ fontSize: { xs: '1.3rem', sm: '1.3rem', md: '2.125rem' }, fontWeight: '500' }}
					>
						${`${selectedGiftCard?.amount} ${selectedGiftCard?.company} Gift Card`}
					</Typography>
					<Typography
						variant='inherit'
						sx={{ fontSize: { xs: '1.3rem', sm: '1.3rem', md: '1.8rem' } }}
					>
						${`${selectedGiftCard?.price}.00`}
					</Typography>
				</Stack>
				<Stack spacing={3} mt={3} direction='row'>
					<FormControl>
						<InputLabel htmlFor='select-card-quantity' sx={{ color: '#000' }}>
							Qty
						</InputLabel>
						<Select
							labelId='select-card-quantity'
							id='select-card-quantity'
							size='small'
							label='Qty'
							inputProps={{ id: 'select-card-quantity' }}
							aria-label={`Select quantity of $${selectedGiftCard.amount} ${selectedGiftCard.company} Gift Card`}
							disabled={isDisabled}
							value={quantity}
							onChange={(e) => setQuantity(e.target.value)}
						>
							{handleQuantitySelect()}
						</Select>
					</FormControl>
					<LoadingButton
						variant='contained'
						loading={hasBeenAdded}
						onClick={handleAddToCart}
						disabled={isDisabled}
						sx={{
							textTransform: 'none',
							borderRadius: (theme) => theme.pixels.bRadius.main,
							px: '25px',
							boxShadow: 'none',
							fontWeight: 600
						}}
					>
						{!hasBeenAdded && confirmAddition ? 'Added to Cart' : 'Add to Cart'}
					</LoadingButton>
				</Stack>
				<Divider sx={{ mt: 5 }} />
				<Stack mt={5} direction='row' spacing={6}>
					{/* TODO load in actual data */}
					<Typography>SKU: {selectedGiftCard?.sku}</Typography>
					<Typography>{`Category: ${sentenceCase(selectedGiftCard?.category)}`}</Typography>
				</Stack>
			</Box>
		</Stack>
	);
};

DetailedCardContent.propTypes = {
	confirmAddition: PropTypes.bool,
	handleAddToCart: PropTypes.func,
	hasBeenAdded: PropTypes.bool,
	quantity: PropTypes.number,
	setQuantity: PropTypes.func,
	selectedGiftCard: PropTypes.object,
	siteId: PropTypes.number,
	subtotal: PropTypes.number,
	userBalance: PropTypes.object
};

export default DetailedCardContent;
